import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useNavigate } from 'react-router-dom'

// Actions
import { obtenerCasosBandeja, obtenerXlsCasosBandeja } from "../../store/actions/encargado-recupero-action";

// Custom Components
import { LoadingComponent } from 'recupero-comunes'
import 'recupero-comunes/dist/index.css'

const BandejaCasos = () => {

    const [loading, setLoading] = useState(false);
   
    const history = useNavigate();
    
    // El hook useSelector (redux) permite acceder al state en nuestro store.
    const data_encargado_recupero = useSelector(state => state.encargado_recupero);
    const { cfg_form, bandeja, xlscasosbandeja,filtros } = data_encargado_recupero;
    
    // El hook useDispatch (redux) permite invocar una action.
    const dispatch = useDispatch();

    const handleReload = () => {

        if (bandeja && bandeja.query) {

            setLoading(true);

            // Obtener última query enviada
            let query = bandeja.query;

            // Ejecutar acción para obtener casos.
            dispatch(obtenerCasosBandeja(query)).then(() => {
                setLoading(false);
            });
        }
    }

    const obtenerExcelBandeja = () => {

        if (bandeja && bandeja.query) {

            setLoading(true);

            // Obtener última query enviada
            let query = bandeja.query;

            // Ejecutar acción para obtener casos.
            dispatch(obtenerXlsCasosBandeja(query));
        }
    }

    useEffect(() => {

        if (xlscasosbandeja) {

            setLoading(false);
            
            var link = document.createElement("a");
            link.download = xlscasosbandeja.filename;
            link.href = "data:" + xlscasosbandeja.mimetype + ";base64," + xlscasosbandeja.xlsxfile;
            link.click();
        }

    }, [xlscasosbandeja]);
    const onClick = (row) => {
       
        var path = ''
        switch (row.IdTarea) {
            
            case 50:
            case 52:             
              path = '/recepciona-caso-asignado'
            break
            case 51:             
                path = '/recupero-extra-judicial'
            break
            case 54:             
                path = '/recupero-judicial'
            break
            case 60:             
                path = '/recepcion-caso-defensa'
            break
            case 61://Gestionar Defensa ExtraJudicial             
                path = '/gestion-caso-defensa'
            break
            case 64://Gestionar Defensa Judicial
                path = '/gestion-caso-defensa'
            break
            case 62://Recepcionar Asignación Defensa Penal (RG-576)
            case 92://Gestionar Defensa Penal (RG-576)
                path = '/gestion-caso-defensa'
            break
            // case 54:             
            //     path = '/formulario'
            //   break
        }
     

            history(path, {
              state: {
                row,
               // myQueryState 
              }
            })
         }

    const obtenerColumnas = () => {

        return [
            { 
                dataField: 'IdCaso', text: cfg_form['bandejatareasabo-grilla-idcaso'], sort: true, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
            },
            { 
                dataField: 'Tarea', text: cfg_form['bandejatareasabo-grilla-tarea'], sort: true, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
            },
            { 
                dataField: 'EstadoCaso', text: cfg_form['bandejatareasabo-grilla-estado'], sort: true, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
            },
            { 
                dataField: 'ResponsableTarea', text: cfg_form['bandejatareasabo-grilla-responsabletarea'], hidden:(filtros && filtros.todos) ? false : true, sort: true, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
            },
            { 
                dataField: 'Siniestro', text: cfg_form['bandejatareasabo-grilla-siniestro'], sort: true, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
            },
            { 
                dataField: 'FechaSiniestro', text: cfg_form['bandejatareasabo-grilla-fechasiniestro'], 
                sort: true, 
                sortFunc: (a, b, order, dataField, rowA, rowB) => {
                    if (order === 'asc') return stringDate2Time(a) - stringDate2Time(b);
                    else return stringDate2Time(b) - stringDate2Time(a);
                }, 
                headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
            },
            { 
                dataField: 'FechaAsignacion', text: cfg_form['bandejatareasabo-grilla-fechaasigcaso'], 
                sort: true, 
                sortFunc: (a, b, order, dataField, rowA, rowB) => {
                    if (order === 'asc') return stringDate2Time(a) - stringDate2Time(b);
                    else return stringDate2Time(b) - stringDate2Time(a);
                }, 
                headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
            },
            { 
                dataField: 'TipoGestion', text: cfg_form['bandejatareasabo-grilla-tipogestion'], sort: true, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
            }, 
            {
                dataField: 'PatenteAsegurado', text: cfg_form['bandejatareasabo-grilla-patenteaseg'], headerStyle: { textAlign: 'center', verticalAlign: 'top', align: 'center' }
            },
            {
                dataField: 'PatenteTercero', text: cfg_form['bandejatareasabo-grilla-patentetro'], headerStyle: { textAlign: 'center', verticalAlign: 'top', align: 'center' }
            },
            { 
                dataField: 'InstanciaJudicial', text: cfg_form['bandejatareasabo-grilla-instanciajudi'], sort: true, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
            }, 
            {
                dataField: 'accion', text: cfg_form['bandejatareasabo-grilla-accion'], isDummyField: true, headerStyle: { textAlign: 'center', verticalAlign: 'top' }, 
                style: { textAlign: 'center', verticalAlign: 'middle' },
                formatter: (cell, row) => {
                    return accionGestionCaso(row);
                }
            }
        ];
    }
    const accionGestionCaso = (row) => {

        if (row.IndGestionTarea == 1) {
            return  <div>
                        <Button type="button" variant="outline-secondary me-md-2" size="sm" onClick={() => onClick(row)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-gear-fill" viewBox="0 0 16 16">
                            <path d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z"/>
                            </svg>
                        </Button>
                    </div>
        } else {
            return <div></div>
        }
    }
    const stringDate2Time = (date) => {
        date = date.split("-");
        return new Date( date[2], date[1] - 1, date[0]).getTime();
    }

    return (
        <div>
            <LoadingComponent show={loading} />
            { cfg_form && bandeja?.casos !==undefined? 
            <ToolkitProvider search bootstrap4 keyField="Id" 
                data={ bandeja && bandeja ? bandeja?.casos : [] } 
                columns={ obtenerColumnas() } defaultSorted={ [{ dataField: 'id', order: 'asc' }] }>
                { 
                props =>                   
                    <div>
                        <div className="bg-secondary text-light rounded mt-4">
                            <h5 className="text-center p-2" style={{backgroundColor:"#4F517A", color:"white"}}>{ `${cfg_form['bandejatareasabo-title-casospend']} (${bandeja && bandeja ? bandeja?.casos?.length : 0})` }</h5>
                        </div>
                        <Row>
                            <Col md={4} className="d-grid gap-2 d-md-flex justify-content-md-start mt-2 mb-2">
                                <Button type="button" variant="success" size="sm" onClick={() => { obtenerExcelBandeja() }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-file-earmark-excel" viewBox="0 0 16 16">
                                    <path d="M5.884 6.68a.5.5 0 1 0-.768.64L7.349 10l-2.233 2.68a.5.5 0 0 0 .768.64L8 10.781l2.116 2.54a.5.5 0 0 0 .768-.641L8.651 10l2.233-2.68a.5.5 0 0 0-.768-.64L8 9.219l-2.116-2.54z"/>
                                    <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>
                                    </svg>
                                </Button>
                            </Col>
                            <Col md={8} className="d-grid gap-2 d-md-flex justify-content-md-end mt-2 mb-2">
                                <Form.Control placeholder="Buscar en la grilla" className="w-25" onChange={(e) => { props.searchProps.onSearch(e.target.value) }}/>
                                <Button type="button" variant="outline-secondary" size="sm" onClick={() => { handleReload() }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                                    <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                                    <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                                    </svg>
                                </Button>
                            </Col>
                        </Row>                        
                        <BootstrapTable { ...props.baseProps } headerWrapperClasses="table-secondary" pagination={ paginationFactory() } noDataIndication={<div className="text-center">No hay registros encontrados</div>} />
                    </div>
                }
            </ToolkitProvider>
            : null }
        </div>
    );
}

export default BandejaCasos;